module.exports = __webpack_public_path__ + "assets/img/W2-2-F.5ebce639.png";